import { defineStore } from "pinia";
import { ref } from "vue";

/**
 * Estado del layout: apertura del drawer.
 *
 * El LayoutService anterior tenía un bug silencioso — el getter `navbar`
 * devolvía `this.state.drawer` — que era inofensivo sólo porque nadie leía
 * `navbar`. Con un store no hay pares getter/setter escritos a mano, así que esa
 * clase de error desaparece.
 */
export const useLayoutStore = defineStore("layout", () => {
  const drawer = ref(true);

  function toggleDrawer() {
    drawer.value = !drawer.value;
  }

  function setDrawer(value: boolean) {
    drawer.value = value;
  }

  return { drawer, toggleDrawer, setDrawer };
});
